import { generateQueryKey } from 'query';

export * from './useTodosQuery';

export const getTodosQueryKey = (params: { pageSize?: number; featured?: boolean }) =>
  generateQueryKey(['todos', params]);
